(function (window) {
  'use strict';

  var EMAIL_RE = /^.+@.+\..+$/;

  function t(key) {
    var i18n = window.buybackPortalI18n || {};
    return i18n[key] || key;
  }

  class BuybackPortalLogin extends HTMLElement {
    connectedCallback() {
      this._form = this.querySelector('[data-bp-login-form]');
      this._renderedAt = this.querySelector('[data-bp-form-rendered-at]');
      if (this._renderedAt) {
        this._renderedAt.value = String(Date.now());
      }
      this._onSubmit = this._handleSubmit.bind(this);
      if (this._form) {
        this._form.addEventListener('submit', this._onSubmit);
      }
      this._onHashChange = this._prefillFromHash.bind(this);
      window.addEventListener('hashchange', this._onHashChange);
      this._prefillFromHash();
      if (window.buybackPortalConfig) {
        var sellBikeLink = this.querySelector('[data-bp-sell-bike-link]');
        if (sellBikeLink) {
          sellBikeLink.href = window.buybackPortalConfig.getSellBikeUrl();
        }
      }
    }

    disconnectedCallback() {
      if (this._form && this._onSubmit) {
        this._form.removeEventListener('submit', this._onSubmit);
      }
      if (this._onHashChange) {
        window.removeEventListener('hashchange', this._onHashChange);
      }
    }

    _prefillFromHash() {
      var hash = window.location.hash || '';
      if (hash.indexOf('#/login') !== 0) return;
      var qIdx = hash.indexOf('?');
      if (qIdx < 0) return;
      var params = new URLSearchParams(hash.slice(qIdx + 1));
      var codeInput = this.querySelector('#bp-code-mint');
      var emailInput = this.querySelector('#bp-email');
      var didPrefill = false;
      var codeRaw = (params.get('code_mint') || '').trim();
      if (codeInput && codeRaw && !codeInput.value.trim()) {
        codeInput.value = codeRaw;
        didPrefill = true;
      }
      var emailRaw = (params.get('email') || '').trim();
      if (emailInput && emailRaw && EMAIL_RE.test(emailRaw) && !emailInput.value.trim()) {
        emailInput.value = emailRaw;
        didPrefill = true;
      }
      if (didPrefill) {
        history.replaceState(null, '', window.location.pathname + window.location.search + '#/login');
        var self = this;
        requestAnimationFrame(function () {
          var codeVal = codeInput && codeInput.value.trim();
          var emailVal = emailInput && emailInput.value.trim();
          var emailOk = emailVal && EMAIL_RE.test(emailVal);
          if (codeVal && emailOk) {
            var btn = self._form && self._form.querySelector('button[type=submit]');
            if (btn) btn.focus();
          } else if (codeInput && !codeVal) {
            codeInput.focus();
          } else if (emailInput && !emailVal) {
            emailInput.focus();
          }
        });
      }
    }

    async _handleSubmit(e) {
      e.preventDefault();
      if (!this._form) return;
      var fd = new FormData(this._form);
      var payload = {
        code_mint: fd.get('code_mint'),
        email: fd.get('email'),
        website: fd.get('website') || '',
        formRenderedAt: Number(fd.get('formRenderedAt')),
      };
      this._setError('');
      this._setBusy(true);
      try {
        await window.buybackApi.login(payload);
        try {
          var listRes = await window.buybackApi.listReprises();
          var reprises = (listRes && listRes.reprises) || (Array.isArray(listRes) ? listRes : []);
          if (Array.isArray(reprises) && reprises.length === 1 && reprises[0] && reprises[0].id) {
            window.location.hash = '#/detail/' + encodeURIComponent(reprises[0].id);
          } else {
            window.location.hash = '#/list';
          }
        } catch (eList) {
          window.location.hash = '#/list';
        }
        window.location.reload();
      } catch (err) {
        if (err.message === 'UNAUTHENTICATED' || err.message === 'HTTP_401') {
          this._setError(t('error_401'));
        } else if (err.message === 'RATE_LIMITED') {
          this._setError(t('error_429'));
        } else {
          this._setError(t('error_generic'));
        }
      } finally {
        this._setBusy(false);
      }
    }

    _setError(msg) {
      var el = this.querySelector('[data-bp-error]');
      if (!el) {
        el = document.createElement('p');
        el.setAttribute('data-bp-error', '');
        el.className = 'buyback-portal__error';
        el.setAttribute('role', 'alert');
        this._form.appendChild(el);
      }
      el.textContent = msg;
      el.hidden = !msg;
    }

    _setBusy(busy) {
      if (!this._form) return;
      var btn = this._form.querySelector('button[type=submit]');
      if (btn) {
        btn.disabled = busy;
        btn.setAttribute('aria-busy', String(busy));
      }
    }
  }

  if (!customElements.get('buyback-portal-login')) {
    customElements.define('buyback-portal-login', BuybackPortalLogin);
  }
})(window);
